<template lang="pug">
  .create-plan_rate-reservation-rates
    .tabs-inner-content
      .row(v-if="plan_rate")
        .columns
          h2 Plan reservation rate
          .row
            .column
              label Name
                input(type="text", v-model="plan_rate.name")
              label Vehicle Category
                selectize-category(@optionSelected="selectCategory", :selectedValue="plan_rate.vehicle_category_id")


              label Reservation rate
                selectize-reservation-rate(@optionSelected="selectRate", :selectedValue="plan_rate.reservation_rate_id")

              label Disabled
                input(type="checkbox", v-model="plan_rate.disabled")
            .column
              BookingModeSelect(v-model="booking_modes", type="checkbox")
          .row
            .columns.text-right
              a.button.success(@click="savePlanRate") Save
</template>
<script type="text/babel">

  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import PlanReservationRate from "../PlanReservationRate.vue";
  import SelectizeCategory from "../../structure/ui/lists/selectize/SelectizeCategory";
  import SelectizeReservationRate from "../../structure/ui/lists/selectize/SelectizeReservationRate";
  import DatePicker from "../../structure/DatePicker";
  import MaggieHelper from "../../../maggieHelper";
  import BookingModeSelect from "../../structure/BookingModeSelect";


  export default {
    name: "PlanReservationRates",
    components: {BookingModeSelect, DatePicker, SelectizeReservationRate, SelectizeCategory, PlanReservationRate},
    data() {
      return {
        plan_rate: null,
        booking_modes: []
      }
    },
    created() {
      KeplerBackofficeSdk.planReservationRates.select(this.$route.params.rateId).get((data) => {
        this.plan_rate = data
        this.booking_modes = data.booking_mode.split(',')
      })
    },
    methods: {
      selectCategory(item) {
        this.plan_rate.vehicle_category_id = item.id
      },
      selectRate(item) {
        this.plan_rate.reservation_rate_id = item.id
      },
      savePlanRate() {
        this.plan_rate.booking_mode = this.booking_modes.join(',')
        KeplerBackofficeSdk.planReservationRates.select(this.$route.params.rateId).edit(this.plan_rate, (data) => {
          MaggieHelper.notification('rate', 'Reservation rate edited')
          this.$router.push({name: 'plan', params: {id: data.plan_id}})
        })

      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .create-plan_rate-reservation-rates
    background: white

</style>



// WEBPACK FOOTER //
// EditPlanReservationRates.vue?3e82771c